import { render, staticRenderFns } from "./GPNotes.vue?vue&type=template&id=3abd6bc2&scoped=true"
import script from "./GPNotes.vue?vue&type=script&lang=js"
export * from "./GPNotes.vue?vue&type=script&lang=js"
import style0 from "./GPNotes.vue?vue&type=style&index=0&id=3abd6bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abd6bc2",
  null
  
)

export default component.exports